import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FEATURE_FLAGS_AUTH_FEATURE_KEY, IFeatureFlagsAuthState } from '@redngapps/feature-flags/data-access';
import { isNil } from 'lodash-es';

const selectFeatureFlagsAuthState = createFeatureSelector<IFeatureFlagsAuthState>(FEATURE_FLAGS_AUTH_FEATURE_KEY);

export const selectFeatureFlagsAuthPending = createSelector(selectFeatureFlagsAuthState, state => state.pending);
export const selectFeatureFlagsLoggedIn = createSelector(selectFeatureFlagsAuthState, state => state.loggedIn);
export const selectFeatureFlagsAccessToken = createSelector(selectFeatureFlagsAuthState, state => state.accessToken);
export const selectFeatureFlagsAuthError = createSelector(selectFeatureFlagsAuthState, state => state.error);
export const selectFeatureFlagsUser = createSelector(selectFeatureFlagsAuthState, state => state.user);
export const selectFeatureFlagsCanWrite = createSelector(
  selectFeatureFlagsAuthState,
  state => state.permissions?.write === true,
);
export const selectFeatureFlagsUserEmail = createSelector(selectFeatureFlagsUser, user =>
  isNil(user) ? null : user.email,
);
